import BreadcrumbRoot from './BreadcrumbRoot'

export default BreadcrumbRoot
